import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Menu, X, User, LogOut } from 'lucide-react';
const Navbar: React.FC = () => {
  const {
    isAuthenticated,
    user,
    logout
  } = useAuth();
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const handleLogout = () => {
    logout();
    navigate('/login');
  };
  return <nav className="bg-white border-b border-gray-200 shadow-sm" data-id="element-267">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-268">
        <div className="flex justify-between h-16" data-id="element-269">
          <div className="flex items-center" data-id="element-270">
            <Link to="/" className="flex-shrink-0 flex items-center" data-id="element-271">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/taYGe4m94o6wHv4LRrE7wo/Logo.png" alt="GoABitFurther Africa Logo" className="h-20 w-auto" data-id="element-272" />
            </Link>
          </div>
          {/* Desktop Navigation */}
          <div className="hidden md:flex md:items-center md:space-x-6" data-id="element-273">
            <Link to="/" className="text-gray-600 hover:text-blue-600 px-3 py-2 rounded-md text-sm font-medium" data-id="element-274">
              Home
            </Link>
            <Link to="/courses" className="text-gray-600 hover:text-blue-600 px-3 py-2 rounded-md text-sm font-medium" data-id="element-275">
              Career Paths
            </Link>
            {isAuthenticated && <Link to="/community" className="text-gray-600 hover:text-blue-600 px-3 py-2 rounded-md text-sm font-medium" data-id="element-276">
                Community
              </Link>}
            <Link to="/resources" className="text-gray-600 hover:text-blue-600 px-3 py-2 rounded-md text-sm font-medium" data-id="element-277">
              Resources
            </Link>
            <Link to="/about" className="text-gray-600 hover:text-blue-600 px-3 py-2 rounded-md text-sm font-medium" data-id="element-278">
              About Us
            </Link>
            <Link to="/contact" className="text-gray-600 hover:text-blue-600 px-3 py-2 rounded-md text-sm font-medium" data-id="element-279">
              Contact
            </Link>
            {isAuthenticated ? <div className="relative ml-3 flex items-center space-x-4" data-id="element-280">
                <div className="flex items-center" data-id="element-281">
                  <div className="bg-blue-100 rounded-full p-2" data-id="element-282">
                    <User size={16} className="text-blue-600" data-id="element-283" />
                  </div>
                  <span className="ml-2 text-sm font-medium text-gray-700" data-id="element-284">
                    {user?.name}
                  </span>
                </div>
                <button onClick={handleLogout} className="flex items-center text-gray-600 hover:text-red-600" data-id="element-285">
                  <LogOut size={16} className="mr-1" data-id="element-286" />
                  <span className="text-sm" data-id="element-287">Logout</span>
                </button>
              </div> : <div className="flex items-center space-x-2" data-id="element-288">
                <Link to="/login" className="px-4 py-2 text-sm font-medium text-blue-600 border border-blue-600 rounded-md hover:bg-blue-50" data-id="element-289">
                  Log in
                </Link>
                <Link to="/signup" className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700" data-id="element-290">
                  Sign up
                </Link>
              </div>}
          </div>
          {/* Mobile menu button */}
          <div className="flex items-center md:hidden" data-id="element-291">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="inline-flex items-center justify-center p-2 rounded-md text-gray-600 hover:text-blue-600 hover:bg-gray-100 focus:outline-none" data-id="element-292">
              {isMenuOpen ? <X size={24} data-id="element-293" /> : <Menu size={24} data-id="element-294" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      {isMenuOpen && <div className="md:hidden" data-id="element-295">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-296">
            <Link to="/" className="block px-3 py-2 rounded-md text-base font-medium text-gray-600 hover:text-blue-600 hover:bg-gray-50" data-id="element-297">
              Home
            </Link>
            <Link to="/courses" className="block px-3 py-2 rounded-md text-base font-medium text-gray-600 hover:text-blue-600 hover:bg-gray-50" data-id="element-298">
              Career Paths
            </Link>
            {isAuthenticated && <Link to="/community" className="block px-3 py-2 rounded-md text-base font-medium text-gray-600 hover:text-blue-600 hover:bg-gray-50" data-id="element-299">
                Community
              </Link>}
            <Link to="/resources" className="block px-3 py-2 rounded-md text-base font-medium text-gray-600 hover:text-blue-600 hover:bg-gray-50" data-id="element-300">
              Resources
            </Link>
            <Link to="/about" className="block px-3 py-2 rounded-md text-base font-medium text-gray-600 hover:text-blue-600 hover:bg-gray-50" data-id="element-301">
              About Us
            </Link>
            <Link to="/contact" className="block px-3 py-2 rounded-md text-base font-medium text-gray-600 hover:text-blue-600 hover:bg-gray-50" data-id="element-302">
              Contact
            </Link>
            {isAuthenticated ? <>
                <div className="px-3 py-2 flex items-center" data-id="element-303">
                  <div className="bg-blue-100 rounded-full p-2" data-id="element-304">
                    <User size={16} className="text-blue-600" data-id="element-305" />
                  </div>
                  <span className="ml-2 text-sm font-medium text-gray-700" data-id="element-306">
                    {user?.name}
                  </span>
                </div>
                <button onClick={handleLogout} className="w-full text-left px-3 py-2 rounded-md text-base font-medium text-gray-600 hover:text-red-600 hover:bg-gray-50 flex items-center" data-id="element-307">
                  <LogOut size={16} className="mr-2" data-id="element-308" />
                  Logout
                </button>
              </> : <div className="px-3 py-2 space-y-2" data-id="element-309">
                <Link to="/login" className="block w-full px-4 py-2 text-center text-sm font-medium text-blue-600 border border-blue-600 rounded-md hover:bg-blue-50" data-id="element-310">
                  Log in
                </Link>
                <Link to="/signup" className="block w-full px-4 py-2 text-center text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700" data-id="element-311">
                  Sign up
                </Link>
              </div>}
          </div>
        </div>}
    </nav>;
};
export default Navbar;